import { dramaCategories } from '@/mocks/dramas';

interface FilterBarProps {
  search: string;
  onSearch: (value: string) => void;
  activeCat: string;
  onCat: (value: string) => void;
  sort: string;
  onSort: (value: string) => void;
  total: number;
}

const sortOptions = [
  { value: 'hot', label: '按热度' },
  { value: 'score', label: '按还原度' },
  { value: 'recent', label: '按更新' },
];

export default function FilterBar({
  search,
  onSearch,
  activeCat,
  onCat,
  sort,
  onSort,
  total,
}: FilterBarProps) {
  return (
    <div className="sticky top-16 md:top-[72px] z-40 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-6">
          <div className="relative w-full lg:w-72 shrink-0">
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400"></i>
            <input
              type="search"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="搜索剧名、题材或标签"
              aria-label="搜索短剧档案"
              className="w-full pl-10 pr-3 py-2.5 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition-colors"
            />
          </div>

          <div className="flex-1 min-w-0 overflow-x-auto no-scrollbar">
            <div className="flex items-center gap-2 w-max">
              <button
                type="button"
                onClick={() => onCat('全部')}
                className={`px-3.5 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
                  activeCat === '全部'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 border border-background-300 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                全部
              </button>
              {dramaCategories.map((cat) => (
                <button
                  key={cat}
                  type="button"
                  onClick={() => onCat(cat)}
                  className={`px-3.5 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
                    activeCat === cat
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 border border-background-300 hover:border-primary-300 hover:text-primary-600'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-3 shrink-0">
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              共 <span className="font-label text-primary-600">{total}</span> 条
            </span>
            <div className="flex items-center gap-1 p-1 rounded-md bg-background-100 border border-background-300">
              {sortOptions.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => onSort(opt.value)}
                  className={`px-3 py-1.5 rounded-md text-xs whitespace-nowrap transition-colors ${
                    sort === opt.value
                      ? 'bg-foreground-950 text-background-50'
                      : 'text-foreground-600 hover:text-primary-600'
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}